import { Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import MccObsCalendar from './components/MccObsCalendar';
import Privacy from './components/Privacy';
import { AddGameContainer } from './components/mccTracker/AddGameContainer';
import { CurlingStatisticsContainer } from './components/mccTracker/CurlingStatisticsContainer';
import { LeagueStandings } from './components/LeagueStandings';
import TradeTree from './components/TradeTree/TradeTree';
import FantasyPreview from './components/FantasyPreview/FantasyPreview';
import TeamPreview from './components/FantasyPreview/TeamPreview';
import { SkipsTracker } from './components/mccTracker/SkipTracker';
import USCAEventStats from './components/USCAEventStats/USCAEventStats';
const Main = () => {
return (         
    <Routes>
    <Route path='/' element={<Home/>} />
    <Route path='/privacy' element={<Privacy/>} />
    <Route path='/addGame' element={<AddGameContainer/>} />
    <Route path='/mccObsCalendar' element={<MccObsCalendar/>} />
    <Route path='/curling' element={<CurlingStatisticsContainer/>} />
    <Route path='/leagueStandings' element={<LeagueStandings/>} />
    <Route path='/leagueStandings.svg' element={<LeagueStandings/>} />
    <Route path='/tradeTree/:leagueId' element={<TradeTree/>} />
    <Route path='/fantasy-preview' element={<FantasyPreview/>} />
    <Route path='/fantasy-preview/team/:teamId' element={<TeamPreview/>} />
    <Route path='/skips' element={<SkipsTracker/>} />
    <Route path='/USCAEventStats' element={<USCAEventStats/>} />
  </Routes>
);
}
export default Main;